import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGetInTouch = () => {
    window.open('https://forms.gle/NwYZnJaLvwkYBQDM6', '_blank');
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <img src="/lexpitchLogo.png" alt="Lex Pitch Logo" className="logo-img" />
          <span className="logo-text">LexPitch <span className="logo-affiliation">IN AFFILIATION With DK& Associates</span></span>
        </div>
        
        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
          <a href="#services" onClick={() => setIsMenuOpen(false)}>Services</a>
          <a href="#how-it-works" onClick={() => setIsMenuOpen(false)}>How It Works</a>
          <a href="#team" onClick={() => setIsMenuOpen(false)}>Founder</a>

          <div className="nav-dropdown">
            <button className="nav-dropdown-btn">
              Consult an Expert
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <div className="dropdown-menu">
              <a href="https://forms.gle/NwYZnJaLvwkYBQDM6" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>Talk to a Lawyer</a>
              <a href="https://forms.gle/NwYZnJaLvwkYBQDM6" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>Business Registration</a>
              <a href="https://forms.gle/NwYZnJaLvwkYBQDM6" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>IP Protection</a>
              <a href="https://forms.gle/NwYZnJaLvwkYBQDM6" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>Compliance Advisory</a>
            </div>
          </div>

          <button className="nav-cta" onClick={handleGetInTouch}>Get in Touch</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
